export const S_TEXT = {
  FORGOT_PASS: 'Forgot Password',
  BLANK_LOGIN_ERROR: 'Please enter email and password',
};

export const TEXT = {
  BY: 'BY',
  URL: 'URL',
  NEW: 'NEW',
  TAG: 'TAG',
  FORM: 'FORM',
  DASH: 'DASH',
  CITY: 'CITY',
  URLS: 'URLS',
  SAVE: 'SAVE',
  TAGS: 'TAGS',
  LOGIN: 'LOGIN',
  HELLO: 'HELLO',
  EMAIL: 'EMAIL',
  CLOSE: 'CLOSE',
  REPLY: 'REPLY',
  CANCEL: 'CANCEL',
  REJECT: 'REJECT',
  SUBMIT: 'SUBMIT',
  FORGOT: 'FORGOT',
  CHANGE: 'CHANGE',
  SEARCH: 'SEARCH',
  LOGOUT: 'LOGOUT',
  UPDATE: 'UPDATE',
  NEW_TAG: 'NEW_TAG',
  TO_USER: 'TO_USER',
  KEYWORD: 'KEYWORD',
  CREATED: 'CREATED',
  TAG_TEXT: 'TAG_TEXT',
  TAG_LIST: 'TAG_LIST',
  ADDED_BY: 'ADDED_BY',
  READ_MORE: 'READ_MORE',
  DOCUMENTS: 'DOCUMENTS',
  YOUR_PASS: 'YOUR_PASS',
  MARK_TEXT: 'MARK_TEXT',
  DATA_TEXT: 'DATA_TEXT',
  SHOW_MORE: 'SHOW_MORE',
  LOGIN_TEXT: 'LOGIN_TEXT',
  SEARCH_FOR: 'SEARCH_FOR',
  OWNER_NAME: 'OWNER_NAME',
  TAG_STATUS: 'TAG_STATUS',
  ADDED_DATE: 'ADDED_DATE',
  TAG_NUMBER: 'TAG_NUMBER',
  APPLICATION: 'APPLICATION',
  TAG_SUMMARY: 'TAG_SUMMARY',
  FORGOT_PASS: 'FORGOT_PASS',
  TAG_DETAILS: 'TAG_DETAILS',
  ATTACHMENTS: 'ATTACHMENTS',
  LAST_30_DAYS: 'LAST_30_DAYS',
  LAST_90_DAYS: 'LAST_90_DAYS',
  DOWNLOAD_ALL: 'DOWNLOAD_ALL',
  APPLICATIONS: 'APPLICATIONS',
  TRANSLATIONS: 'TRANSLATIONS',
  MY_OPEN_TAGS: 'MY_OPEN_TAGS',
  REPLIED_TAGS: 'REPLIED_TAGS',
  NO_DATA_FOUND: 'NO_DATA_FOUND',
  BACK_TO_LOGIN: 'BACK_TO_LOGIN',
  LAST_LOGIN_AT: 'LAST_LOGIN_AT',
  DOCUMENTS_LIST: 'DOCUMENTS_LIST',
  APP_BACKGROUND: 'APP_BACKGROUND',
  PAGE_NOT_FOUND: 'PAGE_NOT_FOUND',
  CONTACT_DETAILS: 'CONTACT_DETAILS',
  LATEST_ACTIVITY: 'LATEST_ACTIVITY',
  DOCUMENT_NUMBER: 'DOCUMENT_NUMBER',
  BACKGROUND_DOCS: 'BACKGROUND_DOCS',
  DOCUMENT_STATUS: 'DOCUMENT_STATUS',
  DEFAULT_DEADLINE: 'DEFAULT_DEADLINE',
  MARK_KEYWORD_LIST: 'MARK_KEYWORD_LIST',
  REQUESTED_DEADLINE: 'REQUESTED_DEADLINE',
  REJECT_APPLICATION: 'REJECT_APPLICATION',
  APPLICATION_NUMBER: 'APPLICATION_NUMBER',
  THIS_IS_ERROR_PAGE: 'THIS_IS_ERROR_PAGE',
  REPLY_AWAITED_TAGS: 'REPLY_AWAITED_TAGS',
  SELECT_FORM_TO_CONT: 'SELECT_FORM_TO_CONT',
  APPLICATION_DETAILS: 'APPLICATION_DETAILS',
  DOWNLOAD_IN_PROGRESS: 'DOWNLOAD_IN_PROGRESS',
  APP_DATA_UPDATE_MESSAGE: 'APP_DATA_UPDATE_MESSAGE',
};
